<!--
  -  配药清单
  -->
<template>
  <el-tabs v-model="activeTab">
    <el-tab-pane label="饮片" name="1">
      <el-table :data="pageData.activeDiagRecord['chmedPrescriptionItemList']">
        <el-table-column prop="materielCode" label="药品编码" align="center" />
        <el-table-column prop="materielName" label="药品名称" align="center" />
        <table-select-item
          :edit="false"
          :width="120"
          name="品质标识"
          code="qualitySign"
          :options="[{key:'1',value:'一般'},{key:'2',value:'精品'}]"
        />
        <table-number-item
          :width="140"
          :precision="2"
          :edit="false"
          name="单剂数量"
          code="singleNum"
        />
        <table-number-item
          :width="140"
          :precision="2"
          :edit="false"
          name="总数量"
          code="sellingNum"
        />
        <table-number-item
          :width="140"
          :precision="2"
          :edit="false"
          name="单价"
          code="salePrice"
        />
        <table-number-item
          :width="140"
          :precision="2"
          :edit="false"
          name="总价"
          code="saleAmount"
        />
      </el-table>
    </el-tab-pane>
    <el-tab-pane label="中成药" name="2">
      <el-table :data="pageData.activeDiagRecord['medPrescriptionItemList']">
        <el-table-column
          width="140"
          prop="materielCode"
          label="药品编码"
          align="center"
        />
        <el-table-column
          width="140"
          prop="materielName"
          label="药品名称"
          align="center"
        />
        <table-select-item
          :width="140"
          :edit="false"
          name="品质标识"
          code="qualitySign"
          :options="[{key:'1',value:'一般'},{key:'2',value:'精品'}]"
        />
        <table-number-item
          :width="140"
          code="sellingNum"
          name="销售数量"
          :edit="false"
        />
        <el-table-column
          width="140"
          prop="medAdvice"
          label="医嘱"
          align="center"
        />
        <table-number-item
          :width="140"
          code="dayNum"
          name="用药天数"
          :edit="false"
        />
        <table-number-item
          :width="140"
          code="dayFreq"
          name="每日次数"
          :edit="false"
        />
        <table-number-item
          :width="140"
          code="freqNum"
          name="每次剂量"
          :edit="false"
        />
        <table-number-item
          code="salePrice"
          name="单价"
          :edit="false"
        />
        <table-number-item
          code="saleAmount"
          name="总价"
          :edit="false"
        />
      </el-table>
    </el-tab-pane>
    <el-tab-pane label="理疗项目" name="3">
      <el-table :data="pageData.activeDiagRecord['servePrescriptionItemList']">
        <el-table-column prop="materielCode" label="编码" align="center" />
        <el-table-column prop="materielName" label="名称" align="center" />
        <ik-column-number
          :column-width="120"
          :edit="false"
          code="sellingNum"
          name="销售数量"
        />
        <!-- <ik-column-number
          :column-width="120"
          :edit="false"
          code="intervalDay"
          name="间隔天数"
        /> -->
        <ik-column-number
          :column-width="120"
          :edit="false"
          code="salePrice"
          name="单价"
        />
        <ik-column-number
          :column-width="120"
          :edit="false"
          code="saleAmount"
          name="总价"
        />
      </el-table>
    </el-tab-pane>
    <el-tab-pane label="代煎处方" name="4">
      <el-table :data="pageData.activeDiagRecord['djPrescriptionItemList']">
        <el-table-column prop="materielCode" label="药品编码" align="center" />
        <el-table-column prop="materielName" label="药品名称" align="center" />
        <table-select-item
          :edit="false"
          :width="120"
          name="品质标识"
          code="qualitySign"
          :options="[{key:'1',value:'一般'},{key:'2',value:'精品'}]"
        />
        <table-number-item
          :width="140"
          :precision="2"
          :edit="false"
          name="单剂数量"
          code="singleNum"
        />
        <table-number-item
          :width="140"
          :precision="2"
          :edit="false"
          name="总数量"
          code="sellingNum"
        />
        <table-number-item
          :width="140"
          :precision="2"
          :edit="false"
          name="单价"
          code="salePrice"
        />
        <table-number-item
          :width="140"
          :precision="2"
          :edit="false"
          name="总价"
          code="saleAmount"
        />
      </el-table>
    </el-tab-pane>
    <el-tab-pane label="代售处方" name="5">
      <el-table :data="pageData.activeDiagRecord['dsPrescriptionItemList']">
        <el-table-column prop="materielCode" label="药品编码" align="center" />
        <el-table-column prop="materielName" label="药品名称" align="center" />
        <table-select-item
          :edit="false"
          :width="120"
          name="品质标识"
          code="qualitySign"
          :options="[{key:'1',value:'一般'},{key:'2',value:'精品'}]"
        />
        <!-- <table-number-item
          :width="140"
          :precision="2"
          :edit="false"
          name="单剂数量"
          code="singleNum"
        /> -->
        <table-number-item
          :width="140"
          :precision="2"
          :edit="false"
          name="总数量"
          code="sellingNum"
        />
        <table-number-item
          :width="140"
          :precision="2"
          :edit="false"
          name="单价"
          code="salePrice"
        />
        <table-number-item
          :width="140"
          :precision="2"
          :edit="false"
          name="总价"
          code="saleAmount"
        />
      </el-table>
    </el-tab-pane>
  </el-tabs>
</template>
<script>
import IkColumnNumber from "@/components/ik/table/ikColumn/IkColumnNumber/index.vue"

export default {
  name: "PrepareMedList",
  components: { IkColumnNumber },
  inject: ["pageData"],
  data() {
    return {
      activeTab: "1"
    }
  }
}
</script>

<style scoped lang="scss">

</style>
